import { Loader2 } from "lucide-react";
import { formatVoiceElapsed, VoiceActivityBars } from "./VoiceActivityBars";

interface CompanionVoiceActiveDisplayProps {
  compact: boolean;
  isProcessing: boolean;
  isListening: boolean;
  elapsedSeconds: number;
}

export function CompanionVoiceActiveDisplay({
  compact,
  isProcessing,
  isListening,
  elapsedSeconds,
}: CompanionVoiceActiveDisplayProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex flex-1 min-w-0 items-center gap-2 ${compact ? "py-2" : "py-3"}`}
    >
      {isProcessing ? (
        <Loader2 className="h-4 w-4 shrink-0 animate-spin text-muted-foreground" />
      ) : (
        <span className="relative flex h-2.5 w-2.5 shrink-0">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-60" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" />
        </span>
      )}
      <span className="min-w-10 ds-caption ds-mono tabular-nums text-foreground/75">
        {formatVoiceElapsed(elapsedSeconds)}
      </span>
      <div className="min-w-0 flex-1">
        <VoiceActivityBars active={isListening} />
      </div>
      <span className="sr-only">
        {isProcessing ? "Sending voice message" : "Recording voice message"}
      </span>
    </div>
  );
}
